import React from 'react'
import MicroFrontend from "../MicroFrontend"

const ErrorBoundaryWidget = () => {
    return <MicroFrontend
        name="ErrorBoundaryWidget"
    />
}

export default (ErrorBoundaryWidget);